import React from 'react';
import cx from 'classnames';
import styles from 'partials/radio.module.scss';

export const RadioItem = (props) => {
	const handleChange = (e) => {
		props.onChange?.(e);
	};
    
    const renderChildren = () => {
		const { label, children } = props;

		if (label) {
			return label;
		}
		if (children) {
			return children;
		}
		return 'title';
	};

	const radioClass = cx({
		[styles.radio_checked]: props.isChecked,
		[props.className]: props.className
	});

	return (
		<div className={radioClass}>
			<label htmlFor={props.id} className={styles.label}>
				<span className={styles.wrapper}>
					<i className={styles.checkmark} />
					<input
						type="radio"
						id={props.id}
						className={styles.input}
						name={props.name}
						checked={props.isChecked}
						onChange={handleChange}
						value={props.value}
						tabIndex={props.tabIndex}
					/>
				</span>
				<span className={styles.title}>{renderChildren()}</span>
			</label>
		</div>
	);
};
